import React from 'react';
import SpaceshipsArea from '../../components/index/SpaceshipsArea';
import WeaponsArea from '../../components/index/WeaponsArea';
import ShieldsArea from '../../components/index/ShieldsArea';
import RepairKitsArea from '../../components/index/RepairKitsArea';

function ShopAreas() {
  return (
    <div className="area-bg-one">
      <section className="shop-area">
        <div className="container">
            <SpaceshipsArea />
            <WeaponsArea />
            <ShieldsArea />
            <RepairKitsArea />
        </div>
      </section>
    </div>
  );
}

export default ShopAreas;
